import type { ActivePaymentProviderDto, UpdatePaymentSettingsDto } from './dto/models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PaymentSettingsService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getActiveProvider = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ActivePaymentProviderDto>({
      method: 'GET',
      url: '/api/app/payment-settings/active-provider',
    },
    { apiName: this.apiName,...config });
  

  setActiveProvider = (input: UpdatePaymentSettingsDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/payment-settings/set-active-provider',
      body: input,
    },
    { apiName: this.apiName,...config });
}